import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { DrugGroupAkaImport } from '../models/drug-group-aka-import.model';

export class PagedDrugGroupAkaImports implements PagedResults {
  drugGroupAkaImports: DrugGroupAkaImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.drugGroupAkaImports;
  }
}

@Injectable()
export class DrugGroupAkaImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<DrugGroupAkaImport> {
    return this.http.get<DrugGroupAkaImport>(
      `${environment.captureApi.url}/drug_group_aka_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
  ): Observable<PagedDrugGroupAkaImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedDrugGroupAkaImports>(
      `${environment.captureApi.url}/drug_group_aka_imports?${params.toString()}`
    );
  }

  create(signedId: string): Observable<DrugGroupAkaImport> {
    return this.http.post<DrugGroupAkaImport>(
      `${environment.captureApi.url}/drug_group_aka_imports`,
      {
        drugGroupAkaImport: { signedId },
      }
    );
  }

  cancel(id): Observable<DrugGroupAkaImport> {
    return this.http.patch<DrugGroupAkaImport>(
      `${environment.captureApi.url}/drug_group_aka_imports/${id}/cancel`,
      {}
    );
  }
}
